import { ReactElement, useEffect, useState } from 'react'
import {
  NativeSyntheticEvent,
  Platform,
  Pressable,
  PressableProps,
  StyleProp,
  StyleSheet,
  TargetedEvent,
  View,
  ViewStyle,
} from 'react-native'

import { Color, Font, Spacing } from '../../style'
import { Text } from '../typography'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  tab: {
    flex: 1,
    padding: Spacing.XS,
    borderBottomWidth: 1,
    borderColor: Color.sleepingGrey,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    marginRight: Spacing.XS,
  },
  selected: {
    borderBottomWidth: 2,
    borderColor: Color.darkGreyBlue,
  },
  selectedText: {
    fontFamily: Font.medium,
  },
  disabled: {
    color: Color.calmGrey,
  },
  active: {
    color: Color.greyBlue,
  },
})

interface Props extends Omit<PressableProps, 'style'> {
  title: string
  style?: StyleProp<ViewStyle>
  selected?: boolean
  accessory?: ReactElement
}

const Tab = (props: Props) => {
  const { title, style, selected, accessory, disabled, onFocus, onBlur, ...otherProps } = props

  const [active, setActive] = useState(false)

  const updateActive = (value: boolean) => (event: NativeSyntheticEvent<TargetedEvent>) => {
    setActive(value)
    value && onFocus && onFocus(event)
    !value && onBlur && onBlur(event)
  }
  useEffect(() => {
    if (disabled) setActive(false)
  }, [disabled])

  function renderTab(state: { pressed: boolean; hovered?: boolean }) {
    const { pressed, hovered } = state
    return (
      <View style={[styles.tab, selected && styles.selected]}>
        <Text
          level={7}
          style={[
            styles.title,
            (hovered || pressed || selected) && styles.selectedText,
            disabled && styles.disabled,
            active && styles.active,
          ]}
        >
          {title}
        </Text>
        {accessory}
      </View>
    )
  }

  return (
    <Pressable
      disabled={disabled}
      onFocus={updateActive(true)}
      onBlur={updateActive(false)}
      style={[
        Platform.select({
          // @ts-expect-error outline style none is not defined
          web: {
            outlineStyle: 'none',
          } as ViewStyle,
        }),
        styles.container,
        style,
      ]}
      {...otherProps}
      testID="Tab.Container"
    >
      {renderTab}
    </Pressable>
  )
}

export default Tab
